import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../styles/NotFound.css";

function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="not-found-icon">🔍</div>
        <h1 className="not-found-code">404</h1>
        <h2 className="not-found-title">{t("notFound.title")}</h2>
        <p className="not-found-subtitle">{t("notFound.subtitle")}</p>
        <Link to="/" className="not-found-button">
          {t("notFound.backHome")}
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
